import { createFileRoute } from "@tanstack/react-router"
import { CompanyAppointmentDetailPage } from "@/features/companies/company-appointment-detail-page"
export const Route = createFileRoute("/_authenticated/companies/$companyId/appointments/$appointmentId")({
    component: RouteComponent,
})
function RouteComponent() {
    const { appointmentId } = Route.useParams()
    return <CompanyAppointmentDetailPage appointmentId={appointmentId} />
}
